import useTranslation from 'next-translate/useTranslation'
import { twMerge } from 'tailwind-merge'
import { Popover } from '@mui/material'

import {
  useResidentialTypesAndSubTypesMethods,
  FiltersResidentialTypesAndSubTypesBaseProps,
} from './use-residential-types-and-sub-types-methods'
import {
  CommonFilterProps,
  POPOVER_FILTER_CONTAINER_STYLE,
  POPOVER_CTA_STYLES,
  POPOVER_HEADER_STYLES,
  POPOVER_BODY_STYLES,
} from '@unreserved-frontend-v2/ui/filters-bar/layout'
import { PopoverFilterCTA } from '@unreserved-frontend-v2/ui/filters-bar/filters'
import { UiToggleButtonGroup } from '@unreserved-frontend-v2/ui/ui-toggle-button-group/ui-toggle-button-group'

export type FiltersResidentialTypesAndSubTypesProps = FiltersResidentialTypesAndSubTypesBaseProps & CommonFilterProps

export function FiltersResidentialTypesAndSubTypes(props: FiltersResidentialTypesAndSubTypesProps) {
  const { t } = useTranslation()
  const { residentialTypes, containerClasses, anchorEl, isOpen, handleFilterToggle, onClose, filterIndex } = props
  const { onResidentialTypeChange, selectedResidentialTypes, subTypes } = useResidentialTypesAndSubTypesMethods(props)

  return (
    <div className={containerClasses} style={POPOVER_FILTER_CONTAINER_STYLE}>
      <div className={POPOVER_CTA_STYLES} onClick={(e) => handleFilterToggle?.(e, filterIndex || 0)}>
        <PopoverFilterCTA
          label={
            residentialTypes.find(({ value }) => {
              return selectedResidentialTypes?.includes(value as string)
            })?.label || t(`listings:type`)
          }
        />
      </div>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 47, horizontal: -1 }}
        open={isOpen}
        onClose={onClose}
        sx={{ '.MuiPaper-root': { padding: 0 } }}
      >
        <div className="h-[234]px w-[358px]">
          <div className={POPOVER_HEADER_STYLES}>{t('listings:property-type')}</div>
          <div className={twMerge(POPOVER_BODY_STYLES, 'px-0 [&>*]:px-6')}>
            <UiToggleButtonGroup
              fullWidth={true}
              onChange={onResidentialTypeChange}
              value={selectedResidentialTypes}
              items={residentialTypes}
              className="bg-white text-xs"
              tileGrid={true}
              dynamicHeight={true}
            />
            {subTypes ? (
              <>
                <hr className="text-shades-200 my-6 px-0" />
                {subTypes}
              </>
            ) : null}
          </div>
        </div>
      </Popover>
    </div>
  )
}

export default FiltersResidentialTypesAndSubTypes
